import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import s from './MediumSophisticatedTooltipHeading.scss';
var MediumSophisticatedTooltipHeading = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("span", __assign({ className: c(s['root'], className) }, rest), children));
};
MediumSophisticatedTooltipHeading.displayName =
    'MediumSophisticatedTooltipHeading';
export default MediumSophisticatedTooltipHeading;
//# sourceMappingURL=MediumSophisticatedTooltipHeading.js.map